import { Typography } from '@mui/material'

import { EventCollectionBoxFragment } from '@/clients/utoniq-core/schema'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import {
  EventCollectionReceiveTimeEditForm,
  EventCollectionReceiveTimeValue,
} from '@/components/pages/ConsoleEventCollectionReceiveTimeEdit/template/EventCollectionReceiveTimeEditForm'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

import { PickupTime } from './components/PickupTimesEditForm'
export * from './fragments'

export type State = {
  loading: boolean
  submitting: boolean
  artistId: string
  eventCollection: EventCollectionBoxFragment | undefined
  eventId: string
  days: string[]
  maxValidMinutes: number
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: (
    values: EventCollectionReceiveTimeValue & {
      pickupTimes: PickupTime[]
    }
  ) => Promise<void>
}

export const ConsoleEventCollectionReceiveTimeEditTemplate: Template<
  State,
  Action
> = ({ state, onSubmit }) => {
  const { routerPages, generatePath } = useRouter()
  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <ConsoleBaseLayout
        margin
        header={{
          back: true,
          title: state.eventCollection?.collection.title,
          defaultBackPage: generatePath(
            routerPages.ConsoleShokufesEventDetail,
            {
              eventId: state.eventId,
            }
          ),
        }}
      >
        <HeadingTextCell />
        {!state.loading && state.days && (
          <EventCollectionReceiveTimeEditForm
            eventCollection={state.eventCollection}
            days={state.days}
            onSubmit={onSubmit}
            submitting={state.submitting}
            maxValidMinutes={state.maxValidMinutes}
          />
        )}
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}

const HeadingTextCell: Cell = () => {
  const { t } = useTranslation('consoleEventCollectionReceiveTimeEdit')
  return (
    <CellFrame sx={{ py: 3, mt: 2 }}>
      <Typography variant="h3">{t('editDeliveryTime')}</Typography>
    </CellFrame>
  )
}
